module.exports = __webpack_public_path__ + "static/media/posting-storm-min.c0ad0e69.webp";